import PropTypes from 'prop-types';

export const jobPropTypes = PropTypes.shape({
  auditEndAt: PropTypes.string,
  auditRealFinishAt: PropTypes.string,
  auditRealStartAt: PropTypes.string,
  auditStartAt: PropTypes.string,
  capGeneratedAt: PropTypes.string,
  clientAlertSentAt: PropTypes.string,
  clientDraftCapSentAt: PropTypes.string,
  clientFinalReportSentAt: PropTypes.string,
  downloadedAt: PropTypes.string,
  externalSaqStartAt: PropTypes.string,
  externalSaqEndAt: PropTypes.string,
  htmlAttachmentId: PropTypes.number,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  internalAlertSubmittedAt: PropTypes.string,
  internalDraftCapSubmittedAt: PropTypes.string,
  internalSaqStartAt: PropTypes.string,
  internalSaqEndAt: PropTypes.string,
  jobAuditors: PropTypes.arrayOf(
    PropTypes.shape({
      isReportWriter: PropTypes.bool,
      user: PropTypes.shape({
        currentVersion: PropTypes.shape({
          firstName: PropTypes.string,
          lastName: PropTypes.string,
        }),
        id: PropTypes.string,
      }),
    }),
  ),
  jobCompanies: PropTypes.arrayOf(
    PropTypes.shape({
      company: PropTypes.shape({
        currentVersion: PropTypes.shape({
          companyAddresses: PropTypes.arrayOf(
            PropTypes.shape({
              currentVersion: PropTypes.shape({
                address1: PropTypes.string,
                countryId: PropTypes.number,
              }),
            }),
          ),
          companyTypes: PropTypes.arrayOf(PropTypes.shape({
            currentVersion: PropTypes.shape({
              name: PropTypes.string,
            }),
            id: PropTypes.number,
          })),
          name: PropTypes.string,
        }),
        id: PropTypes.number,
      }),
    }),
  ),
  jobPrograms: PropTypes.arrayOf(
    PropTypes.shape({
      program: PropTypes.shape({
        currentVersion: PropTypes.shape({
          name: PropTypes.string,
        }),
        id: PropTypes.number,
      }),
    }),
  ),
  jobServices: PropTypes.arrayOf(
    PropTypes.shape({
      service: PropTypes.shape({
        currentVersion: PropTypes.shape({
          name: PropTypes.string,
        }),
        id: PropTypes.number,
      }),
    }),
  ),
  jobStakeholders: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      id: PropTypes.number,
      jobId: PropTypes.number,
      role: PropTypes.string,
      updatedAt: PropTypes.string,
      user: PropTypes.object,
      userId: PropTypes.number,
    })
  ),
  pdfAttachmentId: PropTypes.number,
  reportNames: PropTypes.arrayOf(PropTypes.string),
  reportNumber: PropTypes.string,
  reportSentForFinalQaAt: PropTypes.string,
  reportSentForPreliminalQaAt: PropTypes.string,
  reportUploadedToClientPlatformAt: PropTypes.string,
  requestType: PropTypes.string,
  reviewEndAt: PropTypes.string,
  reviewStartAt: PropTypes.string,
  reviewerId: PropTypes.number,
  sendNotificationTagTimestamp: PropTypes.string,
  specialNotes: PropTypes.string,
  staffDays: PropTypes.number,
  status: PropTypes.string,
  uploadedAt: PropTypes.string,
  windowEndAt: PropTypes.string,
  windowStartAt: PropTypes.string,
});

export const JobFormPropTypes = {
  allAuditorActionsNeededCount: PropTypes.number,
  allNoteCount: PropTypes.number,
  allReviewerActionsNeededCount: PropTypes.number,
  allExternalActionsNeededCount: PropTypes.number,
  capFindingsData: PropTypes.object,
  capFindingsLoading: PropTypes.bool,
  closedNoteCount: PropTypes.number,
  companyTypes: PropTypes.arrayOf(PropTypes.object),
  currentUserPermissions: PropTypes.arrayOf(PropTypes.object),
  fullJobLoading: PropTypes.bool,
  getResultHistories: PropTypes.func,
  isReportReviewer: PropTypes.bool,
  isSavingJobResultsLoading: PropTypes.bool.isRequired,
  job: jobPropTypes.isRequired,
  jobChecklistResults: PropTypes.array,
  jobDatasheetResults: PropTypes.array,
  jobMeta: PropTypes.object,
  loading: PropTypes.bool,
  onSetStatus: PropTypes.func,
  refetchReportReview: PropTypes.func,
  refetchResultHistories: PropTypes.func,
  reloadJob: PropTypes.func,
  reloadJobChecklistResults: PropTypes.func,
  reloadJobDatasheetResults: PropTypes.func,
  reloadCapFindings: PropTypes.func,
  reportReviewData: PropTypes.object,
  reportReviewStatistics: PropTypes.arrayOf(PropTypes.object),
  resultHistories: PropTypes.object,
  saveJobChecklistResults: PropTypes.func,
  saveJobDatasheetResults: PropTypes.func,
  updateCapQueryCache: PropTypes.func,
  isDatasheetResultsLoaded: PropTypes.bool,
};

export const MainStatusesRowPropTypes = {
  userAuthorization: PropTypes.object.isRequired,
  allAuditorActionsNeededCount: PropTypes.number,
  allNoteCount: PropTypes.number,
  allReviewerActionsNeededCount: PropTypes.number,
  allExternalActionsNeededCount: PropTypes.number,
  button: PropTypes.node,
  canUserLoadResults: PropTypes.bool,
  closedNoteCount: PropTypes.number,
  currentUserPermissions: PropTypes.arrayOf(PropTypes.object),
  daysSinceConducted: PropTypes.number,
  dueDate: PropTypes.object,
  finishButtonAvailable: PropTypes.bool,
  finishLoadingResultButton: PropTypes.func,
  hasCapService: PropTypes.bool,
  hasSaqService: PropTypes.bool,
  hasUnverifiedSaqService: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  job: jobPropTypes.isRequired,
  onClick: PropTypes.func,
  onSetStatus: PropTypes.func,
  reopenReviewBtn: PropTypes.node,
  reopenLoadingResultButton: PropTypes.func,
  setIsSubmitting: PropTypes.func,
  setShowSpellCheckPopup: PropTypes.func,
  showButton: PropTypes.bool,
  showReopenCapButton: PropTypes.bool,
  spellCheckButtonAvailable: PropTypes.bool,
  statusLabel: PropTypes.node,
  startLoadingResultButton: PropTypes.func,
  startCAPWithoutReviewButton: PropTypes.func,
};

export const UnderCapStatusPropTypes = {
  allFindingCount: PropTypes.number,
  pendingFindingCount: PropTypes.number,
};
